export default (expirationDate: string) => {
  const currentDate = new Date().getTime();
  const ninetyDays = 90 * 24 * 60 * 60 * 1000;
  const invalidationDate = new Date(expirationDate).getTime() + ninetyDays;
  return currentDate < invalidationDate;
};
